/**
 * @file   src\components\Tutorial\IntroTutorialModal.js
 * @brief  This file is responsible for introduction tutorial
 * @date   May, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import IntroAcceptedImg from "../../images/intro-accepted-img.png";

const IntroTutorialModal = (props) => {
  return (
    <Modal
      show
      centered
      backdropClassName="white-backdrop"
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      className="modal-left-aligned left"
    >
      <Modal.Body className="pt-24 pb-24 pl-24 pr-24">
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={() => {
            props.onHide();
          }}
        ></button>
        <h6>Learn about introductions</h6>
        <p className="mb-4">
          Think your home might be a match? Learn how to introduce properties in
          under 1 minute.
        </p>

        <img src={IntroAcceptedImg} className="mb-4" />

        <Button
          variant=""
          className="btn btn-secondary"
          onClick={() => {
            props.accept();
          }}
        >
          Show me how
        </Button>
      </Modal.Body>
    </Modal>
  );
};
export default IntroTutorialModal;
